import ImageC from 'src/components/Image';
import style from './style.module.less';
function Disclaimer() {
  return <div className={style.disclaimer}>
			<div className="d-flex">
				<div className={style.disclaimer__left}>
					<div className={style.disclaimer__header}>
						<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/logoInformasi.svg" width={24} height={24} style={{
            margin: '5px'
          }} />
						<h5 style={{
            marginLeft: '10px'
          }}>Info Untuk Mama</h5>
					</div>
					<p>
						Kalkulator ini bukanlah sebuah alat diagnosis medis ataupun pengganti konsultasi dokter
						spesialis kandungan dan kesuburan. Alat ini hanya untuk prediksi masa subur yang bisa
						Mama lakukan mandiri, sebaiknya tetap konsultasi ke dokter agar tahu lebih pasti kondisi
						kesehatan Mama saat ini. Merencanakan kehamilan? Segerakan konsultasi lanjutan!
						Konsultasi Sekarang
					</p>
				</div>
			</div>
		</div>;
}
export default Disclaimer;